
import React from "react";
import { Outlet, NavLink, useParams, useNavigate } from "react-router-dom";
import { apiFetch } from "../../utils/api";
import "./Layout.css";

const LearningPathLayout = () => {
  const { name } = useParams();
  const navigate = useNavigate();
  const [displayName, setDisplayName] = React.useState("");

  // Extract ID from name (slug-id)
  const parts = name.split("-");
  const id = parts[parts.length - 1];

  React.useEffect(() => {
    const fetchName = async () => {
      try {
        const email = localStorage.getItem("userEmail");
        const data = await apiFetch(`${window._env_.API_BASE_URL}/learning_paths/${id}?user_email=${encodeURIComponent(email)}`);
        if (data && data.name) {
          setDisplayName(data.name);
        }
      } catch (err) {
        console.error("Error fetching LP name:", err);
        // Fallback to URL part if fetch fails
        let fallback = parts.slice(0, -1).join(" ");
        setDisplayName(fallback.charAt(0).toUpperCase() + fallback.slice(1));
      }
    };
    fetchName();
  }, [id, parts]);

  return (
    <main id="mlpl-main-content">
      <div className="mlpl-container">
        <div className="mlpl-breadcrumb">
          <span
            onClick={() => navigate("/manage-learning-paths")}
            className="mlpl-breadcrumb-link"
          >
            Manage Learning Path
          </span>
          <span className="mlpl-breadcrumb-separator"> &gt; </span>
          <span className="mlpl-breadcrumb-current">{displayName || "Loading..."}</span>
        </div>
        {/* 
        <div className="mlpl-page-title-section">
          <div className="mlpl-title-text">
            <h1>{displayName}</h1>
            <p className="mlpl-subtitle">Learning Path</p>
          </div>
        </div> */}

        <div className="mlpl-content-card">
          <nav className="mlpl-course-tabs">
            <ul>
              <li>
                <NavLink
                  to={`/manage-learning-paths/${name}/overview`}
                  className={({ isActive }) => (isActive ? "mlpl-active" : "")}
                >
                  Overview
                </NavLink>
              </li>
              <li>
                <NavLink
                  to={`/manage-learning-paths/${name}/courses`}
                  className={({ isActive }) => (isActive ? "mlpl-active" : "")}
                >
                  Courses
                </NavLink>
              </li>
              <li>
                <NavLink
                  to={`/manage-learning-paths/${name}/users`}
                  className={({ isActive }) => (isActive ? "mlpl-active" : "")}
                >
                  Users
                </NavLink>
              </li>
            </ul>
          </nav>

          <div className="mlpl-content-panel">
            <Outlet />
          </div>
        </div>
      </div>
    </main>
  );
};

export default LearningPathLayout;